import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType  } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {fieldEdit_template} from "../components/templates/fieldEdit_template";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class field_edit extends vnModule_knockoutJS{
    protected fieldEdit : fieldEdit_template
    protected XHRHdl: XMLHttpRequestHandler;
    protected _isLeavePageWarningNeeded: boolean = true;

    buildContent(): Array<Element> {
        this.fieldEdit = new fieldEdit_template('fieldEdit', this.viewModel, this)
        return [this.fieldEdit.build()]
    }

    protected getModuleName(): string {
        return "field_edit";
    }

    public fillPage() {
        this.getFieldDataForEdit()
    }

    private getFieldDataForEdit() {
        this.loadingIn(this.fieldEdit.builtTemplate);

        let url : string = '/api/brand/' + this.getVnAppZone().app.params.idBrand + '/field/get/edit/' + this.getVnAppZone().app.params.id + '/';
        let request_parameters : Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(url, request_parameters, this);
        this.XHRHdl.onReadyStateFunction = this.onGetFieldDataForEdit;
        this.XHRHdl.execute();
    }

    private onGetFieldDataForEdit(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);
                let field = responseParsed.data
                obj.setFieldData(field);

            });
            obj.loadingOut(obj.fieldEdit.builtTemplate);
        }
    }

    protected setFieldData(field) {
        this.fieldEdit.setId(field.id)
        this.fieldEdit.setIdField(field.idField)
        this.fieldEdit.setLabel(field.label)
        this.fieldEdit.setType(field.type)
    }

    public cancelForm() {
        this.onClickCancelEdit();
    }

    public onClickCancelEdit(){
        let brandId = this.getVnAppZone().app.params.idBrand
        page.redirect("/brand/" + brandId + "/newsletter/fields/")
    }


    protected save() {
        this.loadingIn(this.fieldEdit.builtTemplate);

        let idBrand = this.getVnAppZone().getApp().params.idBrand;

        let formReq_url: string = '/api/brand/' + idBrand + "/field/save/";
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.viewModel));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        let XHRHdl: XMLHttpRequestHandler = new XMLHttpRequestHandler(formReq_url, formReq_params, this);
        XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        XHRHdl.onReadyStateFunction = (function (req, obj) {

            return function () {

                obj.manageResponse(req, obj, function () {

                    page.redirect('/brand/' + idBrand + "/newsletter/fields/");

                    if (req.request.status === 200) {
                        obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, "Field saved !");
                        //obj.getVnAppZone().showNotificationToModule();
                    }
                });
                obj.loadingOut(obj.fieldEdit.builtTemplate);
            }
        });
        XHRHdl.execute();
    }
}


// WEBPACK FOOTER //
// ./js/modules/field_edit.ts